import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(url: string, type: 'resourceUrl' | 'html' = 'resourceUrl'): SafeResourceUrl | SafeHtml {
    switch (type) {
      case 'resourceUrl':
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
      case 'html':
        return this.sanitizer.bypassSecurityTrustHtml(url);
      default:
        throw new Error(`Invalid type: ${type}`);
    }
  }
}
